import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import Clock from "./components/Clock/Clock";
import Projects from "./components/Projects/Projects";
import LivingStatues from "./components/Projects/LivingStatues";
import AtlantaGalleryEvents from "./components/AtlantaGalleryEvents";
import Confluences from "./components/Confluences";
import MITMASPortfolio from "./components/MITMASPortfolio/MITMASPortfolio";
import LivDay2026 from "./components/LivDay2026";
import ProjectData from "./Data/Projects.json";
import ProjectPage from "./components/Projects/Project Page";

import {
  HashRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        {/* <Navbar /> */}
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/mitmasportfolio" element={<MITMASPortfolio />} />
          <Route path="/livingstatues" element={<LivingStatues />}/>
          <Route path="/atlantagalleryevents" element={<AtlantaGalleryEvents />}/>
          <Route path="/confluences" element={<Confluences />}/>
          <Route path="/project/:id" element={<ProjectPage />}/>
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/clock" element={<Clock />} />
          <Route path="/livday2026" element={<LivDay2026 />} />
          <Route path="*" element={<Navigate to="/"/>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
